module.exports = __webpack_public_path__ + "static/media/filePublic.2537e54c.png";